export const DOCUMENT_QUESTION_TYPES = ['file', 'document', 'document upload', 'file upload'];

function empty_object() {
  return Object.create(null);
}

function object_value(source, key, fallback = '') {
  if (!source || typeof source !== 'object') return fallback;
  if (!Reflect.has(source, key)) return fallback;
  const value = Reflect.get(source, key);
  return value === undefined || value === null ? fallback : value;
}

function first_value(source, keys, fallback = '') {
  const found_key = keys.find((key) => object_value(source, key, '') !== '');
  return found_key ? object_value(source, found_key, fallback) : fallback;
}

export function parse_response_data(payload) {
  if (typeof payload !== 'string') return payload || empty_object();

  const trimmed_payload = payload.trim();
  if (!trimmed_payload) return empty_object();

  try {
    return JSON.parse(trimmed_payload);
  } catch {
    return empty_object();
  }
}

export function extract_response_items(payload) {
  const response_data = parse_response_data(payload);
  const items = response_data.data || response_data.results || response_data;
  return Array.isArray(items) ? items : [];
}

export function extract_rules_response_items(payload) {
  const response_data = parse_response_data(payload);
  const items = response_data.rules || response_data.data || response_data.results;
  return Array.isArray(items) ? items : [];
}

export function normalize_form(form) {
  const id = first_value(form, ['id', 'form_id']);

  return Object.assign(empty_object(), {
    id,
    form_name: first_value(form, ['form_name', 'name'], `Form ${id}`),
    form_description: first_value(form, ['form_description', 'description'])
  });
}

export function normalize_rule(rule) {
  const id = first_value(rule, ['id', 'compliance_rule_id']);

  return {
    id,
    name: first_value(rule, ['name', 'rule_name'], `Rule ${id}`),
    description: object_value(rule, 'description'),
    initial_grace_period: object_value(rule, 'initial_grace_period'),
    frequency: object_value(rule, 'frequency'),
    recurring_grace_period: object_value(rule, 'recurring_grace_period'),
    logical_operator: object_value(rule, 'logical_operator'),
    trigger_status: object_value(rule, 'trigger_status'),
    trigger_statuses: object_value(rule, 'trigger_statuses'),
    trigger_status_ids: object_value(rule, 'trigger_status_ids'),
    trigger_status_name: object_value(rule, 'trigger_status_name')
  };
}

export function normalize_transition_rule(rule) {
  const from_status_object = object_value(rule, 'from_status', empty_object());
  const to_status_object = object_value(rule, 'to_status', empty_object());
  const transition_type_object = object_value(rule, 'transition_type', empty_object());
  const from_status = first_value(from_status_object, ['status_name'], object_value(rule, 'from_status_name', 'From status'));
  const to_status = first_value(to_status_object, ['status_name'], object_value(rule, 'to_status_name', 'To status'));
  const transition_type = first_value(transition_type_object, ['name'], object_value(rule, 'transition_type_name', 'Transition'));

  return Object.assign({}, rule, {
    id: first_value(rule, ['id', 'transition_rule_id']),
    name: `${from_status} to ${to_status}`,
    description: `${transition_type}${object_value(rule, 'is_active', true) === false ? ' - inactive' : ''}`,
    condition: object_value(rule, 'condition', empty_object())
  });
}

export function build_document_record(question, section, sub_section, selected_form_id, form_name, question_type) {
  const question_id = first_value(question, ['question_id', 'id', 'section_question_id']);
  const section_name = first_value(sub_section, ['section_name'], first_value(section, ['main_section_name', 'name']));
  const section_question_id = object_value(question, 'section_question_id', 0);

  return Object.assign(empty_object(), {
    id: `${selected_form_id}-${section_question_id || question_id}`,
    section_question_id: Number(section_question_id),
    name: object_value(question, 'question_text', `Document ${question_id}`),
    description: first_value(question, ['question_description'], section_name || form_name),
    type: question_type || 'File',
    status: object_value(question, 'is_mandatory', false) ? 'Required' : 'Optional',
    date_uploaded: '',
    preview_url: '',
    section_name,
    form_name,
    raw_question: question
  });
}
